import { render, staticRenderFns } from "./AssetInput.vue?vue&type=template&id=af97ab8e&"
import script from "./AssetInput.vue?vue&type=script&lang=js&"
export * from "./AssetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports